export default __webpack_public_path__ + "fc637324a55bd433137d8b9e52a3f233.svg";